import React, { Component } from 'react';
import {Grid, Row, Col, Button, Carousel} from 'react-bootstrap';
import {Link}from 'react-router-dom';


import logoBodor from './images/Logos_Lieferanten/bodor.png';
import logoAero from './images/Logos_Lieferanten/aeroLift.png';
import logoLoewer from './images/Logos_Lieferanten/loewer.png';
import logoFetzer from './images/Logos_Lieferanten/fetzer.png';
import logoAalbers from './images/Logos_Lieferanten/aalbersfarina.png';
import logoDemmeler from './images/Logos_Lieferanten/demmeler.png';

import prodHighlight1 from './supplier/bodor/images/infoJumbo2.jpg'
import prodHighlight2 from './supplier/aalbers/images/infoJumbo4.jpg'
import prodHighlight3 from './supplier/loewer/images/infoJumbo4.png'
import prodHighlight4 from './supplier/demmeler/images/infoJumbo4.jpg'


class Highlight extends Component {
  constructor(props, context) {
    super(props, context);
  }

  

  render() {
    return (
        <div className='container-fluid highlightMain'>
          <div className="hightlightText">
              <Grid>
                <Row>
                  
                  <Col xsHidden sm={6}>
                    <h1>Mauersberger Hausaustellung</h1>
                    <br/>
                    <h3>Demonstrations & Innovationstage</h3>
                    <h3>Stahl- und Blechbearbeitung</h3>
                    <br/>
                    <h3>27. - 29. Januar 2026</h3>
                    <br/>
                    <h2>Themen</h2>
                    <br/>
                    <div className="timeLineHighlight">
                        <div className="dataPoint"><p/> <h4>Laser Schneiden</h4></div><br/>
                        <div className="dataPoint"><p/> <h4>Handgeführtes Laserschweißen Wassergekühlt</h4></div><br/>
                        <div className="dataPoint"><p/> <h4>Entgrat- und Verrundungsmaschinen</h4></div><br/>
                        <div className="dataPoint"><p/> <h4>3D Arbeits- und Schweißsysteme</h4></div><br/>
                        <div className="dataPoint"><p/> <h4>Lager- und Logistiklösungen</h4></div><br/>
                        <div className="dataPoint"><p/> <h4>Vakuumhebetechnik</h4></div><br/>
                        <div class="lineInContext"></div>
                    </div>
                  </Col>
                  
                  <Col xs={12} smHidden mdHidden lgHidden>
                    <h1>Mauersberger Hausaustellung</h1>
                    <br/>
                    <h3>Demonstrations & Innovationstage</h3>
                    <h3>Stahl- und Blechbearbeitung</h3>
                    <br/>
                    <h3>27. - 29. Januar 2026</h3>
                    <br/>
                    <h4>bei</h4>
                    <h4>Mauersberger Industrievertretungen e.K.</h4>
                    <h4>Dinkelsbühler Str. 5</h4>
                    <h4>90574 Buchschwabach</h4>
                    <br/>
                    <br/>
                    <h2>Themen</h2>
                    <br/>
                    <div className="timeLineHighlight">
                        <div className="dataPoint"><p/> <h4>Laser Schneiden</h4></div><br/>
                        <div className="dataPoint"><p/> <h4>Handgeführtes Laserschweißen Wassergekühlt</h4></div><br/>
                        <div className="dataPoint"><p/> <h4>Entgrat- und Verrundungsmaschinen</h4></div><br/>
                        <div className="dataPoint"><p/> <h4>3D Arbeits- und Schweißsysteme</h4></div><br/>
                        <div className="dataPoint"><p/> <h4>Lager- und Logistiklösungen</h4></div><br/>
                        <div className="dataPoint"><p/> <h4>Vakuumhebetechnik</h4></div><br/>
                        <div class="lineInContext"></div>
                    </div>
                  </Col>
                  <Col xsHidden sm={6}>
                    <Carousel  controls={false} interval={3000}>
                      <Carousel.Item >
                          <img  src={prodHighlight1}  alt="Bodor P12"  height="100%" />
                      </Carousel.Item>
                      <Carousel.Item>
                          <img  src={prodHighlight2} alt="Aalbers farina logic"  height="100%"/>
                      </Carousel.Item>
                      <Carousel.Item>
                          <img  src={prodHighlight3} alt="Loewer"  height="100%" />
                      </Carousel.Item>
                      <Carousel.Item>
                          <img  src={prodHighlight4} alt="Demmeler 3D System"  height="100%" />
                      </Carousel.Item>
                    </Carousel>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <h4>bei</h4>
                    <h4>Mauersberger Industrievertretungen e.K.</h4>
                    <h4>Dinkelsbühler Str. 5</h4>
                    <h4>90574 Buchschwabach</h4>
                    <br/>
                    <br/>
                  </Col>
                </Row>
                <br/>
                <h2>Lieferanten vor Ort</h2>
                <br/>
                  
                <Row>
                  <Col xs={12}  sm={3}>
                      <Link to="/Suppliers/Bodor"><img className="supplierImagesOverview"  src={logoBodor} alt="Bodor Logo" width="100%"/></Link>
                  </Col>
                  <Col xs={12} sm={9} className="supplierOverviewDesc">
                      <Link to="/Suppliers/Bodor">
                        <h3>Bodor Laser – Präzision in Lichtgeschwindigkeit</h3>
                        <h4 className="verticalAlign">Bodor Laserschneidanlagen vereinen modernste Faserlasertechnologie mit hoher Schnittgeschwindigkeit, Präzision und automatisierten Funktionen für eine effiziente und sichere Metallbearbeitung in der Industrie.</h4>
                      </Link>
                    </Col>
                </Row>
                <hr/>
                <Row>
                  <Col xs={12}  sm={3}>
                      <Link to="/Suppliers/Demmeler"><img className="supplierImagesOverview"  src={logoDemmeler} alt="Demmeler Logo" width="100%"/></Link>
                  </Col>
                  <Col xs={12} sm={9} className="supplierOverviewDesc">
                      <Link to="/Suppliers/Demmeler">
                        <h3>3D-Schweißtische und Manipulatoren  „Das Original“</h3>
                        <h4 className="verticalAlign">Mit dem Universal 3D Arbeits- und Schweißtisch können sowohl im horizontalen als auch im vertikalen Bereich alle Anforderungen erfüllt werden. Exakt, schnell und im Handumdrehen bauen Sie mit diesem modularen Baukastensystem Ihre Teile auf: Maschinengehäuse, Gestelle, Rahmen, Traversen, Konsolen, Geländer, Treppen, Tore, Schaltschränke, Blechverkleidungen u.v.m. </h4>
                      </Link>
                    </Col>
                </Row>
                <hr/>
                <Row>
                  <Col xs={12}  sm={3}>
                      <Link to="/Suppliers/LOEWER"><img className="supplierImagesOverview"  src={logoLoewer} alt="Loewer Logo" width="100%"/></Link>
                  </Col>
                  <Col xs={12} sm={9} className="supplierOverviewDesc">
                      <Link to="/Suppliers/LOEWER">
                        <h3>Innovative Bürst- und Bandschleifmaschinen</h3>
                        <h4 className="verticalAlign">Innovative Bürst- und Bandschleifmaschinen zum Lösen spezieller Schleifaufgaben. Die Anwendungsschwerpunkte liegen dabei beim Finishschliff und beim Entgraten flächiger Werkstücke. Insbesondere die Entgratschleifmaschinen im Durchlaufverfahren für den Naß- oder Trockenschliff zeugen von preisbewußter Qualität - made in Germany.</h4>
                      </Link>
                    </Col>
                </Row>
                <hr/>
                <Row>
                  <Col xs={12}  sm={3}>
                      <Link to="/Suppliers/Aerolift"><img className="supplierImagesOverview"  src={logoAero} alt="Aerolift Logo" width="100%"/></Link>
                  </Col>
                  <Col xs={12} sm={9} className="supplierOverviewDesc">
                        <Link to="/Suppliers/Aerolift">
                          <h3>Heben mit Vakuumhebetechnik </h3>
                          <h4 className="verticalAlign">AERO-LIFT ist Spezialist für Vakuumhebetechnik. Eine breite Produktpalette, Individuallösungen, hohe Qualität "Made in Germany" und guter Service zeichnen das mittelständische Unternehmen von der Schwäbischen Alb aus. </h4>
                      </Link>
                    </Col>
                </Row>
                <hr/>
                <Row>
                  <Col xs={12}  sm={3}>
                      <Link to="/Suppliers/aalbersfarina"><img className="supplierImagesOverview"  src={logoAalbers} alt="Aalbers Farina Logo" width="100%"/></Link>
                  </Col>
                  <Col xs={12} sm={9} className="supplierOverviewDesc">
                      <Link to="/Suppliers/aalbersfarina">
                        <h3>Moderne Lagersysteme zur Blech und Langgutlagerung</h3>
                        <h4 className="verticalAlign">Durch das intelligente Desing mit Schubladen kann die Lagerkapazität im Vergleich zu konventionellen Lösungen um 50% erhöht werden.</h4>
                      </Link>
                    </Col>
                </Row>
                <hr/>
                <Row>
                  <Col xs={12}  sm={3}>
                      <Link to="/Suppliers/fetzer"><img className="supplierImagesOverview"  src={logoFetzer} alt="Fetzer Logo" width="100%"/></Link>
                  </Col>
                  <Col xs={12} sm={9} className="supplierOverviewDesc">
                      <Link to="/Suppliers/fetzer">
                        <h3>Lager- und Logistiklösungen</h3>
                        <h4 className="verticalAlign">Das Unternehmen Fetzer bietet die Planung, Konstruktion, Fertigung, Service und Montage von Lager- und Logistiklösungen aus einer Hand an. </h4>
                      </Link>
                    </Col>
                </Row>
              </Grid>
          </div>
          <br/>
          <br/>
          <br/>

          
        </div>
    );
  }
}

export default Highlight;



// WEBPACK FOOTER //
// ./src/components/pages/highlight.js